import { render, staticRenderFns } from "./ShelfByStereoscopic.vue?vue&type=template&id=64988d0a"
import script from "./ShelfByStereoscopic.vue?vue&type=script&lang=js"
export * from "./ShelfByStereoscopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports